import {mount} from "./mount";
import {FlowBuilderSettings} from "@/config/flowBuilderSettings";
import {Node, Edge} from "@xyflow/react";

interface FlowBuilderProps {
  containerId: string;
  jwt: string;
  modelId: string;
  backendENV?: string;
  demoMode?: boolean;
  minimapEnabled?: boolean;
  demoData?: {
    nodes: Node[];
    edges: Edge[];
  };
  workspaceId: string;
  onModeChange?: () => void;
}

declare global {
  interface Window {
    FlowBuilder: {
      init: (props: FlowBuilderProps) => void;
    };
  }
}

const FlowBuilder = {
  init: ({
    containerId,
    jwt,
    modelId,
    backendENV,
    demoMode = false,
    minimapEnabled = true,
    demoData,
    workspaceId,
    onModeChange,
  }: FlowBuilderProps) => {
    FlowBuilderSettings.jwt = jwt;
    FlowBuilderSettings.modelId = modelId;
    FlowBuilderSettings.backendENV = backendENV;
    FlowBuilderSettings.demoMode = demoMode;
    FlowBuilderSettings.minimapEnabled = minimapEnabled;
    FlowBuilderSettings.demoData = demoData;
    FlowBuilderSettings.workspaceId = workspaceId;
    FlowBuilderSettings.onModeChange = onModeChange;
    mount(containerId);
  },
};

window.FlowBuilder = FlowBuilder;

export default FlowBuilder;
